import React from 'react';

import { SeverityLabel } from 'controls/react/severityIndicator';
import { Severity } from 'framework/entities/healthData/index';
import { i18n } from 'core/localization';
import { AntSelectOption } from 'controls/react/ant/ant-select/types';

export const severitySelectRender = (option: AntSelectOption) => <SeverityLabel severity={option.value as Severity} />;

let severityOptions: AntSelectOption[];
export function getSeverityOptions(): AntSelectOption[] {
	if (severityOptions == null) {
		severityOptions = [
			{
				value: Severity.None,
				label: i18n('None'),
			},
			{
				value: Severity.Minor,
				label: i18n('Minor'),
			},
			{
				value: Severity.Major,
				label: i18n('Major'),
			},
			{
				value: Severity.Critical,
				label: i18n('Critical'),
			},
		];
	}

	return severityOptions;
}

let severitySelectProps: Record<string, any>;
export function getSeveritySelectProps() {
	if (severitySelectProps == null) {
		severitySelectProps = {
			options: getSeverityOptions(),
			labelRender: severitySelectRender,
			optionRender: severitySelectRender,
		};
	}

	return severitySelectProps;
}
